<template>
	<div class="view pa24">
		<el-form :model="serchParams" class="demo-form-inline" :inline="true">
			<el-row style="padding-top: 20px;">
        <el-form-item label="业务日期" label-width="100px" label-position="left" class="fromItem" prop="startTime">
          <el-date-picker v-model="serchParams.timeRange" type="daterange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="业务类型" label-width="100px" label-position="left" class="fromItem" prop="startTime">
          <el-select v-model="serchParams.type" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" label-width="100px" label-position="left" class="fromItem" prop="startTime">
          <el-select v-model="serchParams.status" placeholder="请选择">
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
				<el-form-item  label="发货方" label-width="100px" label-position="left"
					class="fromItem" prop="dealerId">
					<el-select v-model="serchParams.fromDealerId" placeholder="请选择" filterable @change="chooseDl">
						<el-option v-for="item in dlOptions" :key="item.id" :label="item.dealerName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
        <el-form-item  label="收货方" label-width="100px" label-position="left"
                       class="fromItem" prop="dealerId">
          <el-select v-model="serchParams.toDealerId" placeholder="请选择" filterable>
            <el-option v-for="item in dealerOptions" :key="item.id" :label="item.dealerName"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
				<el-button type="primary" @click="search">搜索</el-button>
				<el-button @click="resetSearch">重置</el-button>
        <el-button :loading="exportLoadding" icon="el-icon-download" type="warning" @click="exportLog">导出</el-button>
			</el-row>
		</el-form>
		<commonTable :tableData="tableData" :total="total" :currentPage="pageNum" :loading="tableLoading" @handleSizeChange="handleSizeChange"
			@handleCurrentChange="handleCurrentChange">
			<template v-slot:table>
				<el-table-column prop="lotNumber" align="center" label="批次号" />
				<el-table-column prop="day" align="center" label="业务日期" />
				<el-table-column prop="nickName" align="center" label="状态" >
          <template>
            已完成
          </template>
        </el-table-column>
				<el-table-column prop="nickName" align="center" label="业务类型" >
          <template>
            分销出库
          </template>
        </el-table-column>
				<el-table-column prop="fromDealerName" align="center" label="发货方" />
				<el-table-column prop="toDealerName" align="center" label="收货方" />
				<el-table-column prop="toDealerName" align="center" label="出库数" >
          <template slot-scope="scope">
            {{scope.row.boxNum||'0'}}箱+{{scope.row.packNum||'0'}}盒
          </template>
        </el-table-column>
        <el-table-column prop="toDealerName" align="center" label="出库盒数" >
          <template slot-scope="scope">
            {{scope.row.allPackNum||'0'}}盒
          </template>
        </el-table-column>
				<el-table-column align="center" width="200" label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="goDetail(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</template>
		</commonTable>
  <out-detail ref="detail"></out-detail>
	</div>
</template>

<script>
	import commonTable from "@/components/common/commonTable";
  import outDetail from "@/pages/dealerLog/componenets/outDetail.vue";
  import {
    dealerOutLog, getDealerList,exportOutLog
  } from '@/api/crk.js'
	export default {
		name: "dealerOutLog",
		components: {
			commonTable,outDetail
		},
		data() {
			return {
				tableData: [],
				pageSize: 10,
				pageNum: 1,
				total: 0,
				wareStatus: 2,
				serchParams: {
					fromDealerId: '',
					toDealerId: '',
					timeRange: [],
          type:1,
          status:1
				},
				dealerOptions: [],
				dlOptions: [],
        exportLoadding:false,
        tableLoading:false,
        options:[
          {value:1,label:'分销出库'}
        ],
        statusOptions:[
            {value:1,label:'已完成'},
        ]
			};
		},
		created() {
			// 获取所有代理商、经销商列表
      this.getDlList()
      this.getDealerList(null)
      this.getList()
		},
		methods: {
			classIdChange() {

			},
			copy(context) {
				// 创建输入框元素
				let oInput = document.createElement('input');
				// 将想要复制的值
				oInput.value = context;
				// 页面底部追加输入框
				document.body.appendChild(oInput);
				// 选中输入框
				oInput.select();
				// 执行浏览器复制命令
				document.execCommand('Copy');
				// 弹出复制成功信息
				this.$message.success('复制成功');
				// 复制后移除输入框
				oInput.remove();
			},
			handleSizeChange(num) {
				this.pageSize = num;
				this.pageNum = 1;
				this.getList();
			},
			handleCurrentChange(num) {
				this.pageNum = num;
				this.getList();
			},
			// 过滤掉空的children
			formatData(data) {
				for (var i = 0; i < data.length; i++) {
					if (data[i].children == null || data[i].children.length == 0) {
						data[i].children = undefined;
					} else if (data[i].children.length > 1) {
						this.formatData(data[i].children);
					}
				}
				return data;
			},
			getDealerList(parentId) {
        getDealerList({type:2,parentId:parentId}).then(res=>{
          this.dealerOptions = res.data
        })
			},
      getDlList() {
        getDealerList({type:1}).then(res=>{
          this.dlOptions = res.data
        })
      },
			search() {
				this.pageNum = 1
				this.getList()
			},
			resetSearch() {
				this.serchParams.fromDealerId = ''
				this.serchParams.toDealerId = ''
				this.serchParams.timeRange = []
				this.pageNum = 1
				this.getList()
			},
			getList() {
				this.tableLoading = true
				let params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					wareStatus: this.wareStatus,
					fromDealerId: this.serchParams.fromDealerId,
					toDealerId: this.serchParams.toDealerId,
					startTime: this.serchParams.timeRange && this.serchParams.timeRange.length > 0 ? this.serchParams
						.timeRange[0] : '',
					endTime: this.serchParams.timeRange && this.serchParams.timeRange.length > 0 ? this.serchParams
						.timeRange[1] : '',
				}
        dealerOutLog(params).then(res => {
					this.tableData = res.data.list
					this.total = res.data.total
				}).finally(() => {
					this.tableLoading = false
				})
			},
      chooseDl(){
        this.serchParams.toDealerId = ''
        this.getDealerList(this.serchParams.fromDealerId)
      },
      goDetail(row){
        this.$refs.detail.init(row.id)
      },
      exportLog(){
        this.exportLoadding = true
        let params={
          wareStatus: this.wareStatus,
          fromDealerId: this.serchParams.fromDealerId,
          toDealerId: this.serchParams.toDealerId,
          startTime: this.serchParams.timeRange && this.serchParams.timeRange.length > 0 ? this.serchParams
              .timeRange[0] : '',
          endTime: this.serchParams.timeRange && this.serchParams.timeRange.length > 0 ? this.serchParams
              .timeRange[1] : '',
        }
        exportOutLog(params).then(result=>{
          this.exportLoadding = false
          const url = window.URL.createObjectURL(result.data);
          const temp =result.fileName.split(";")[1].split("filename=")[1];
          const fileName = decodeURIComponent(temp)
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName );
          document.body.appendChild(link);
          link.click();
        }).catch(e=>{
          this.exportLoadding = false
          this.$message.error(e.message)
        })
      }
		}
	}
</script>

<style lang="scss" scoped>
	.name_status {
		display: inline-block;
		width: 26px;
		height: 17px;
		line-height: 15px;
		background: rgba(63, 114, 246, 0.11);
		border: 1px solid #3F72F6;
		border-radius: 4px;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3F72F6;
		text-align: center;
	}

	.name_status1 {
		display: inline-block;
		width: 26px;
		height: 17px;
		line-height: 15px;
		background: rgba(243, 136, 46, 0.11);
		border: 1px solid #F3882E;
		border-radius: 4px;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #F3882E;
		text-align: center;
	}

	.copyTxt {
		display: inline-block;
		margin-left: 5px;
		cursor: pointer;
		color: #3F72F6;
	}
</style>
